// filepath: frontend/src/components/ui/Skeleton.tsx

interface SkeletonProps {
  className?: string;
  lines?: number;
}

export function Skeleton({ className = '', lines = 1 }: SkeletonProps) {
  if (lines === 1) {
    return <div className={`skeleton h-4 rounded ${className}`} />;
  }
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="skeleton h-4 rounded"
          style={{ width: i === lines - 1 ? '60%' : '100%', opacity: 1 - i * 0.1 }}
        />
      ))}
    </div>
  );
}

export function ShipmentCardSkeleton() {
  return (
    <div className="rounded-[8px] p-5 space-y-3" style={{ background: 'var(--navy-surface)', border: '1px solid var(--color-border)' }}>
      <div className="flex items-center justify-between">
        <Skeleton className="w-28 h-5" />
        <Skeleton className="w-20 h-5 rounded-full" />
      </div>
      <Skeleton className="w-48 h-4" />
      <Skeleton className="w-full h-2 rounded-full" />
      <div className="flex gap-3">
        <Skeleton className="w-16 h-4" />
        <Skeleton className="w-16 h-4" />
      </div>
    </div>
  );
}

export function TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 py-3 px-4" style={{ borderBottom: '1px solid var(--color-border)' }}>
          <Skeleton className="w-28 h-4" />
          <Skeleton className="flex-1 h-4" />
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-16 h-4 rounded-full" />
        </div>
      ))}
    </div>
  );
}
